export default "__VITE_ASSET__B7dU7t96__"